(()=>{
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce){document.documentElement.classList.add('od-motion-ready');document.querySelectorAll('.od-reveal').forEach(el=>el.classList.add('is-visible'));return;}
  const boot=()=>{
    document.documentElement.classList.add('od-motion-ready');
    const els=document.querySelectorAll('.od-reveal');
    if(!('IntersectionObserver' in window)){els.forEach(el=>el.classList.add('is-visible'));return;}
    const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target)}}),{threshold:.08,rootMargin:'0px 0px -40px'});
    els.forEach(el=>io.observe(el));
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
